import React, { Component } from 'react';
import axios from 'axios';
import { connect } from "react-redux";
import ScanWorkflowC240 from './c240_workflow'
import { CameraOutlined, DownloadOutlined, PoweroffOutlined} from '@ant-design/icons';
import { watchPollStatus } from "../../action/device_status.action";
import { sagaMiddleware } from "../../helper/store";
import cookie from "react-cookies";
import {updateEditorState, updateLoaderState} from '../../action/c240_loader.action'
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { getDeviceStatus } from "../../action/device_status.action";
import {
    UpSquareOutlined,
    CloseCircleOutlined,
} from '@ant-design/icons';
import { globalUrlPrefix, cassetteType, C240SlideStatus } from "../../utils/const"
import { Redirect } from 'react-router-dom';

import {
    Badge,
    Tag,
    Row,
    Col,
    Button,
    message,
    List,
    Card,
    Typography,
    Tooltip,
    Modal,
    Spin
} from 'antd';
// import {Switch} from 'antd';
import { AuthHeader } from "../../helper/auth.token";
import GatePrompt from "../../component/scanner/scanWorkflow/c240_gate_prompt.js";

const { Text } = Typography;

// shows a high level info view of each tray in rack
// with info whether preview/scan taken or in queue
// and whether barcode taken
// has two modes based on whether use is super user or not
class RackView extends Component {
    constructor(props) {
        super(props);
    }

    getRackColor = (status) => {
        if (status === 'INSIDE_RACK') {
            return '#66CC66';
        } else if (status === 'ON_FEEDER') {
            return '#FFCC99';
        } else if (status === "ON_STAGE") {
            return "#00CCFF";
        }
        return "#B0B0B0";
    }

    getRackDiffColor = (status) => {
        if (status === 'NO_CHANGE') {
            return 'grey';
        } else if (status === 'INSERTED') {
            return '#013220';
        } else if (status === "REMOVED") {
            return "red";
        } else if (status === "REPLACED") {
            return "yellow";
        }
        return "grey";
    }

    toolTipInfo = (i,j,racks) => {
        return(
            <div>
            <Row style={{ display: "flex"}}>
                <Col span={14}> {"Slot " + (i === 0 ? "R" : "L") + (j+1)} </Col>
            </Row>
            <Row>
                <Col>
                    <Badge color= {this.getRackColor(racks[i][j].cassette_state._name_)}/>
                    {(racks[i][j].cassette_state._name_).replaceAll('_'," ") === "EMPTY" ? "Slot is Empty" : "Cassette is " + (racks[i][j].cassette_state._name_).replaceAll('_'," ")}
                </Col>
                {(racks[i][j].cassette_state._name_).replaceAll('_'," ") === "EMPTY" ? null : 
                <Col>
                    <CassetteBarcodeState barcodeTaken={racks[i][j].barcode_taken}></CassetteBarcodeState>
                    {racks[i][j].barcode_taken ? "Barcode taken" : "Barcode not taken"}
                </Col>
                }
            </Row>
            </div>
        )
    }

    render() {
        let racks_table = [];
        
        let racks = this.props.racks;

        for (let i = racks.length-1; i >= 0; i--) {
            let toolTipPosition = i === 0 ? "right" : "left";
            if (this.props.is_superuser) {
                let thisrack = [];
                for (let j = racks[i].length - 1; j >= 0; j--) {
                    let myCassetteType = (((racks[i][j] || {}).cassette_type || {})._name_ || cassetteType.SIX_1_BY_3_SLIDES);                    
                    let slots = [];
                    if (myCassetteType === cassetteType.TWO_2_BY_3_SLIDES){
                        slots = [0, 1];
                    }else{
                        slots = [0, 1, 2, 3, 4, 5];
                    }
                    const key = `R${i}T${j}`;
                        thisrack.push(
                            <Row key={key}>
                                <Card 
                                    className="less-padded-ant-card-body"
                                    bodyStyle={{ padding: "4px !important" }}
                                    onClick={(e) => {e.stopPropagation(); this.props.onSelectCassette(key)}}
                                    bordered={true}
                                    style={this.props.selected_cassette === key ? {
                                            backgroundColor: this.getRackColor(racks[i][j].cassette_state._name_),
                                            border: "solid yellow",
                                            padding: "2px !important",
                                            marginTop:"2px",
                                            lineHeight: "21px"
                                        } : {
                                            backgroundColor: this.getRackColor(racks[i][j].cassette_state._name_),
                                            border: "solid black",
                                            borderWidth: "0.01px",
                                            padding: "2px !important",
                                            marginTop:"2px",
                                            lineHeight: "21px"
                                        }}>
                                    <Row style={{ display: "flex",alignItems: "center"}}>                                
                                    <Col span={12} style={{fontSize:'0.5vw',paddingLeft:'0.2vw'}} >
                                    {j + " : " + racks[i][j].cassette_state._name_.replaceAll("_", " ")}
                                    </Col>
                                    <Col span={1.5}>
                                        <CassetteBarcodeState barcodeTaken={racks[i][j].barcode_taken}></CassetteBarcodeState>
                                    </Col>
                                    
                                    <Col span={5}>
                                        {this.props.is_superuser ? 
                                        <Button size="small" style={{ fontSize: "11px", height: "17px"}} loading={this.props.loadings["take_thumbnails"]} onClick={() => {
                                                this.props.enterLoading("take_thumbnails");
                                                this.props.call("take_thumbnails", "?rack=" + i + "&tray=" + j);
                                            }} ghost>
                                                <CameraOutlined />
                                        </Button> : null}
                                    </Col>
                                    <Col >
                                        {this.props.is_superuser ? 
                                        <Button size="small" style={{ fontSize: "11px", height: "17px"}} loading={this.props.loadings["rack_to_stage"]} onClick={() => {
                                                this.props.enterLoading("rack_to_stage");
                                                this.props.call("rack_to_stage", "?rack=" + i + "&tray=" + j);
                                            }} ghost>
                                                <DownloadOutlined />
                                        </Button> : null}
                                    </Col>
                                    </Row>
                                    <Row style={{ display: "flex", alignItems: "center", paddingLeft:'0.2vw'}}>
                                    
                                    <Tooltip 
                                        placement={toolTipPosition} 
                                        title={
                                            <div>
                                                {slots.map((value) => {
                                                    return <Row key={value.toString()} style={{ display: "flex"}}>
                                                        <Col>Slot {value+1}</Col>
                                                        <Col style={{ marginLeft:"10px"}}>
                                                            <InSlideState currentSlideState={(this.props.slideLevelScanPreviewStatus[key + "S" + value]||{}).slideState}></InSlideState>
                                                        </Col>                                            
                                                        <Col>
                                                            {((this.props.slideLevelScanPreviewStatus[key + "S" + value]||{}).slideState||"INITIAL").replaceAll('_'," ")}
                                                        </Col>
                                                    </Row>})
                                                }
                                            </div>} 
                                        color="#2db7f5" >
                                        <div style={{ display: "flex"}}>
                                            {slots.map((value) => {
                                                return <Col key={value.toString()}>
                                                    <InSlideState currentSlideState={(this.props.slideLevelScanPreviewStatus[key + "S" + value]||{}).slideState}></InSlideState>
                                                </Col>})}
                                        </div>
                                    </Tooltip>
                                    
                                    <Col align="Right">
                                        <Tag style={{fontSize:'0.5vw',marginRight: "0px",marginTop: "0px",padding: "1px 1px",lineHeight: "10px"}} color={this.getRackDiffColor(racks[i][j].diff_cassette_state._name_)}>
                                            {racks[i][j].diff_cassette_state._name_}</Tag>
                                    </Col >
                                    </Row>
                                </Card>
                            </Row>
                        );
                }
                racks_table.push(
                <Col key={`rack-${i === 0 ? "R" : "L"}`} offset={0} style={{marginLeft: "4px"}} span={11} >
                    <span style={{ fontSize: "12px" }}>Rack {i === 0 ? "R" : "L"}</span>
                    {thisrack}
                </Col>);
            } else {
                let thisrack = [];
                for (let j = racks[i].length - 1; j >= 0; j--) {                    
                    let myCassetteType = (((racks[i][j] || {}).cassette_type || {})._name_ || cassetteType.SIX_1_BY_3_SLIDES);                    
                    let slots = [];
                    if (myCassetteType === cassetteType.TWO_2_BY_3_SLIDES){
                        slots = [0, 1];
                    }else{
                        slots = [0, 1, 2, 3, 4, 5];
                    }
                    const key = `R${i}T${j}`;
                    thisrack.push(                                             
                        <Row key={key}>
                            <Tooltip placement={toolTipPosition} title={
                                    <div>
                                        {this.toolTipInfo(i,j,racks)}
                                        {(racks[i][j].cassette_state._name_).replaceAll('_'," ") === "EMPTY" ? null : 
                                        slots.map((value) => {
                                            return (<Row key={value.toString()} style={{ display: "flex"}}>
                                                <Col>Slide {value+1}</Col>
                                                <Col style={{ marginLeft:"10px"}}><InSlideState currentSlideState={(this.props.slideLevelScanPreviewStatus[key + "S" + value]||{}).slideState}></InSlideState></Col>                                            
                                                <Col>{((this.props.slideLevelScanPreviewStatus[key + "S" + value]||{}).slideState||"INITIAL").replaceAll('_'," ") === C240SlideStatus.INITIAL 
                                                        ? "Awaiting Action" : ((this.props.slideLevelScanPreviewStatus[key + "S" + value]||{}).slideState||"INITIAL").replaceAll('_'," ") }</Col>
                                            </Row>)})
                                        }
                                        
                                    </div>} color="#2db7f5" >
                            <Card 
                                className="less-padded-ant-card-body"
                                bodyStyle={{ padding: "4px !important" }}
                                onClick={(e)=>{e.stopPropagation(); this.props.onSelectCassette(key)}}
                                bordered={true}
                                style={
                                    this.props.selected_cassette === key ? {
                                        // backgroundColor: this.getRackColor(racks[i][j].cassette_state._name_),
                                    border: `solid ${this.getRackColor(racks[i][j].cassette_state._name_)}`,
                                    borderWidth: "3 px",
                                    padding: "2px !important",
                                    marginTop:"2px",
                                    lineHeight: "21px"
                                    }:{
                                        // backgroundColor: this.getRackColor(racks[i][j].cassette_state._name_),
                                    borderLeft: `solid ${this.getRackColor(racks[i][j].cassette_state._name_)}`,
                                    borderWidth: "3 px",
                                    padding: "50px !important",
                                    marginTop:"2px",
                                    lineHeight: "21px"
                                    }
                                }>
                                {/* <Row style={{ display: "flex"}}> */}
                                <Row>
                                    <div >
                                        <Col span={5} style={{fontSize:'0.7vw',paddingLeft:'0.4vw'}} >
                                        {/* for user view only  */}
                                        {j+1}
                                        </Col>
                                        <Col span={3}>
                                            {(racks[i][j].cassette_state._name_).replaceAll('_'," ") === "EMPTY" ? null : 
                                            <CassetteBarcodeState barcodeTaken={racks[i][j].barcode_taken}></CassetteBarcodeState>}
                                        </Col>
                                    </div>
                                    <div style={{ marginLeft:"15px"}}>
                                        {(racks[i][j].cassette_state._name_).replaceAll('_'," ") === "EMPTY" ? null : 
                                        slots.map((value) => {return <Col key={value.toString()} span={2}>
                                        <InSlideState currentSlideState={(this.props.slideLevelScanPreviewStatus[key + "S" + value]||{}).slideState}></InSlideState>
                                        </Col>})
                                        }
                                    </div>
                                
                                </Row>
                            </Card>
                            </Tooltip>
                        </Row>
                    );
                }
                racks_table.push(
                <Col key={`rack-${i === 0 ? "R" : "L"}`} offset={0} style={{marginLeft: "4px"}} span={11} >
                    <span style={{ fontSize: "12px" }}>Rack {i === 0 ? "R" : "L"}</span>
                    {thisrack}
                </Col>);
            }
        }
        return racks_table;
    }
}

// task queue for what is ongoing and what is next in the queue
class ScanPreviewQueueView extends Component {
    constructor(props) {
        super(props);
    }

    queueTitle = (taskType) => {
        if (taskType === "TAKE_SLIDE_PREVIEW") {
            return "Preview of ";
        } else if(taskType === "TAKE_AUTO_SCAN") {
            return "Auto Scan of ";
        } else if(taskType === "TAKE_SCAN_OF_SELECTED_REGION") {
            return "Scan of ";
        } else if(taskType === "OPEN_GATE") {
            return "Open Gate ";
        } else {
            return taskType.replaceAll("_"," ")
        }
    }

    render() {
        let queue_items = [];
        if (this.props.queue_state['ongoing'] === null  && this.props.queue_state['queue'].length === 0) {
            queue_items.push(
            <Card key={"q-empty"} className="less-padded-ant-card-body" bordered={true} style={{width:'260px', marginLeft:'-6px'}} key={"EMPTY"}>
                <Row style={{fontSize:'0.65vw', marginLeft:'2px'}}> {"Queue empty"} </Row>
            </Card>);
        } else {
            let ongoing;
            if (this.props.queue_state['ongoing'] !== null) {
                const {rack, tray, slide} = this.props.queue_state['ongoing'];
                const taskType = this.props.queue_state['ongoing']['taskType'];
                let key = `R${rack}T${tray}`
                ongoing = (
                <Col  key={"on-going"}>
                    <Tooltip placement="left" title={`${this.queueTitle(taskType)}Slot ${rack === 0 ? "R" : "L"}${tray+1}, Slide ${slide+1}`}>
                        <Card className="less-padded-ant-card-body" bordered={true} style={{border: `solid #18A558`,width:'253px', marginLeft:'-7px', cursor:'pointer'}} key={`R${rack === 0 ? "R" : "L"}T${tray}S${slide}`}
                            onClick={(e)=>{e.stopPropagation();this.props.onSelectCassette(key)}}>
                            <Row style={{fontSize:'0.65vw', marginLeft:'2px' }}>
                                {`${this.queueTitle(taskType)}${rack === 0 ? "R" : "L"}${tray+1}-S${slide+1}`}
                                <br></br>
                            </Row>
                        </Card>
                    </Tooltip>
                </Col>);
            } else {
                ongoing = (
                <Tooltip placement="left" title={"Not doing anything right now. Device busy or nothing to do."}>
                    <Card key={"on-going-empty"} className="less-padded-ant-card-body" bordered={true} key={"EMPTY"}
                    // backgroundColor: "#18A558"
                    style={{width:'260px', marginLeft:'-6px', cursor:'pointer', border: `solid #18A558`}}>
                        <Row style={{fontSize:'0.65vw', marginLeft:'2px'}}> {"Nothing ongoing"}</Row>
                    </Card>
                </Tooltip>);
            }
            queue_items.push(ongoing);
            const queue_elems = this.props.queue_state['queue'];
            for (const elem of queue_elems) {
                const {rack, tray, slide} = elem;
                const taskType = elem['taskType'];
                let key = `R${rack}T${tray}`
                queue_items.push(
                <Row key={`q-item-${key}S${slide}-${taskType}`}>
                    <Tooltip placement="left" title={`${this.queueTitle(taskType)}Slot ${rack === 0 ? "R" : "L"}${tray+1}, Slide ${slide+1}`}>
                        <Card className="less-padded-ant-card-body" bordered={true} 
                            style={{ width:'253px', marginLeft:'-8px', cursor:'pointer'}} key={`R${rack === 0 ? "R" : "L"}T${tray}S${slide}`}
                            onClick={(e)=>{e.stopPropagation();this.props.onSelectCassette(key)}}>
                            <Row align ="right" style={{fontSize:'0.65vw', marginLeft:'2px'}}>
                                <Col span={18}>
                                    {`${this.queueTitle(taskType)}${rack === 0 ? "R" : "L"}${tray+1}-S${slide+1}`}
                                </Col>
                                {(elem!=queue_elems['0'] && elem!=queue_elems['1'])?<Col span={6}>
                                {(elem!=queue_elems['2']) ? 
                                <Tooltip placement="top" title={"Prioritise Task"}>
                                    <Button style={{ border:'0px', height: "18px",padding:"0px 3px"}} onClick={(e)=>{this.props.prioritiseTask(e, rack, tray, slide, taskType)}}>
                                        <UpSquareOutlined />
                                    </Button>
                                </Tooltip> : <Col span={8}></Col>}
                                <Tooltip placement="top" title={"Cancel Task"}>
                                    <Button style={{border:'0px', height: "18px",padding:"0px 7.5px"}} onClick={(e)=>{this.props.removeTask(e, rack, tray, slide, taskType)}}>
                                        <CloseCircleOutlined />
                                    </Button>
                                </Tooltip></Col>:null}
                            </Row>
                        </Card>
                    </Tooltip>
                </Row>);
            }
       }
       return queue_items;
    }
}

class CassetteBarcodeState extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let cassette_barcode_state = [];
        if (this.props.barcodeTaken === true) {
            cassette_barcode_state.push(<Badge key={"0"} status="success" />);
        } else {
            cassette_barcode_state.push(<Badge key={"1"} status="default" />);
        }
        return cassette_barcode_state;
    }
};


class InSlideState extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let in_slide_state = [];
        if (this.props.currentSlideState === "PREVIEW_ONGOING" || this.props.currentSlideState === "SCAN_ONGOING") {
            in_slide_state.push(<Badge key={"0"} color="yellow" />);
        } else if (this.props.currentSlideState === "PREVIEW_DONE") {
            in_slide_state.push(<Badge key={"1"} color="blue" />);
        } else if (this.props.currentSlideState === "PREVIEW_IN_QUEUE" 
                    || this.props.currentSlideState === "SCAN_IN_QUEUE"
                    || this.props.currentSlideState === "AUTO_SCAN_IN_QUEUE") {
            in_slide_state.push(<Badge key={"2"} color="orange" />);
        } else if (this.props.currentSlideState === "SCAN_DONE") {
            in_slide_state.push(<Badge key={"3"} color="green" />);
        } else if (this.props.currentSlideState === "SCAN_CRASHED") {
            in_slide_state.push(<Badge key={"4"} color="red" />);
        } else {
            in_slide_state.push(<Badge key={"5"} color="grey" />);
        }
        return in_slide_state;
    }
};

const getDebugButtonList = (loadings, enterLoadingFn, callFn) => {
    let buttons = [];
    buttons.push(<Button type="primary" loading={loadings["health~connection"]} onClick={() => {
        enterLoadingFn("health~connection");
        callFn("health~connection");
    }}>
        Board Connected ?
    </Button>);
    
    buttons.push(<Button type="primary" loading={loadings["health~start"]} onClick={() => {
        enterLoadingFn("health~start");
        callFn("health~start");
    }}>
        Start Server
    </Button>);
    
    buttons.push(<Button type="primary" loading={loadings["health~stop"]} onClick={() => {
        enterLoadingFn("health~stop");
        callFn("health~stop");
    }}>
        Stop Server
    </Button>);
    
    buttons.push(<Button type="primary" loading={loadings["init"]} onClick={() => {
        enterLoadingFn("init");
        callFn("init");
    }}>
        Init
    </Button>);

    buttons.push(<Button type="primary" loading={loadings["update_sensors"]} onClick={() => {
        enterLoadingFn("update_sensors");
        callFn("update_sensors");
    }}>
        Update Sensors
    </Button>);

    buttons.push(<Button type="primary" loading={loadings["stage_to_rack"]} onClick={() => {
        enterLoadingFn("stage_to_rack");
        callFn("stage_to_rack");
    }}>
        Stage To Rack
    </Button>);

    buttons.push(<Button type="primary" loading={loadings["user_interaction_start"]} onClick={() => {
        enterLoadingFn("user_interaction_start");
        callFn("user_interaction_start");
    }}>
        Start Interacting
    </Button>);
    return buttons;
}

const initQPreviewBtnDisableState = () => {
    let qPreviewBtnDisable = {};
    for (let rack = 0; rack < 2; rack++) {
        for (let tray = 0; tray < 20; tray++) {
            const cassette_key = `R${rack}T${tray}`;
            qPreviewBtnDisable[cassette_key] = Array(6).fill(false);
        }
    }
    return qPreviewBtnDisable;
}
const initQScanBtnDisableState = () => {
    let qScanBtnDisable = {};
    for (let rack = 0; rack < 2; rack++) {
        for (let tray = 0; tray < 20; tray++) {
            const cassette_key = `R${rack}T${tray}`;
            qScanBtnDisable[cassette_key] = Array(6).fill(false);
        }
    }
    return qScanBtnDisable;
}
export class C240ControlPanelView extends Component {

    constructor(props) {
        super(props);
        this.device_id = this.props.match.params.id;
        this.timer = null;
        this.timer2 = null;
        this.is_superuser_loggedin = cookie.loadAll().superuser === "true";
        this.state = {
            server_up: true,
            data: null,
            last_res: null,
            loadings: {},
            queue_state: {ongoing: null, queue: []},
            scanner_state: {},
            selected_cassette: "R0T0", // null or string key like "R0T11"
            modal_visible: false,
            is_superuser: false,
            gate_is_open: false,
            show_long_loader: false,
            change_scan_region: false,  // used to hide/show rack view
            barcodeCacheBustingKey: (new Date()).getTime(),
            qPreviewBtnDisable: initQPreviewBtnDisableState(),
            qScanBtnDisable: initQScanBtnDisableState(),
            finalizingSlideSettings: false, // becomes true on clicking "Finalize slide setting" btn, false after http call
            shuttingDown: false,
            show_removed_tasks: false // when true shows which scan/previews were removed
        }
    }

    // used as callback method when user clicks on "Finalize slide setting" btn
    onFinalizeSlideSettingsClick = () => {
        this.setState({ finalizingSlideSettings: true });
    }

    // used as callback method when "Finalize slide setting" finishes or fails
    onFinalizedSlideSettings = () => {
        this.setState({ finalizingSlideSettings: false });
    }

    // used as a callback method when user clicks on Preview Only btn
    onPreviewOnlyClick = (cassette_key, slide_idx) => {
        // eg cassette_key is "R0T1", slide_idx is int, that belongs to [0, 1, 2, 3, 4, 5]
        console.debug("qPreviewBtnDisable is", this.state.qPreviewBtnDisable);
        let _qPreviewBtnDisable = this.state.qPreviewBtnDisable;  // reference copy
        _qPreviewBtnDisable[cassette_key][slide_idx] = true;
        this.setState({
            qPreviewBtnDisable: _qPreviewBtnDisable
        });
    }

    // used as a callback method when preview btn should be enabled again
    enablePreviewBtn = (cassette_key, slide_idx) => {
        // eg cassette_key is "R0T1", slide_idx is int, that belongs to [0, 1, 2, 3, 4, 5]
        let _qPreviewBtnDisable = this.state.qPreviewBtnDisable;  // reference copy
        _qPreviewBtnDisable[cassette_key][slide_idx] = false;
        this.setState({
            qPreviewBtnDisable: _qPreviewBtnDisable
        });
    }

    onQScanClick = (cassette_key, slide_idx) => {
        // eg cassette_key is "R0T1", slide_idx is int, that belongs to [0, 1, 2, 3, 4, 5]
        console.debug("qScanBtnDisable is", this.state.qScanBtnDisable);
        let _qScanBtnDisable = this.state.qScanBtnDisable;  // reference copy
        _qScanBtnDisable[cassette_key][slide_idx] = true;
        this.setState({
            qScanBtnDisable: _qScanBtnDisable
        });
    }

    enableQScanBtn = (cassette_key, slide_idx) => {
        // eg cassette_key is "R0T1", slide_idx is int, that belongs to [0, 1, 2, 3, 4, 5]
        let _qScanBtnDisable = this.state.qScanBtnDisable;  // reference copy
        _qScanBtnDisable[cassette_key][slide_idx] = false;
        this.setState({
            qScanBtnDisable: _qScanBtnDisable
        });
    }
    
    // used as a callback method when user changes scan region
    onStartChangeScanRegion = () => {
        // user is selecting scan region
        this.setState({ change_scan_region: true });
    }

    // used as a callback method when user finalizes scan region
    onFinalizeScanRegion = () => {
        // user finalized scan region
        this.setState({ change_scan_region: false });
    }

    getStatus = (callback=null) => {
        let url = `/scano/1/api~hts~status/`;
        axios.get(url, { headers: { Authorization: AuthHeader() } })
            .then(response => {
                if (response.status !== 200) {
                    message.error("Error");
                    this.setState({
                        server_up: false
                    })
                } else {
                    console.debug("res-data", response.data)
                    this.setState({
                        data: response.data,
                        server_up: true
                    })
                    if (callback !== null) {
                        callback(response.data);
                    }
                }
            })
            .catch(err => {
                console.log(err);
                this.setState({
                    server_up: false
                })
            })
    };

    updateScannerState = () => {
        let url = `/scano/1/api~hts~scanner_state/`;
        axios.get(url, { headers: { Authorization: AuthHeader() } })
            .then(response => {
                if (response.status !== 200) {
                    message.error("Error getting scanner state");
                } else {
                    this.setState({
                        queue_state: response.data.scanPreviewQueue,
                        scanner_state: response.data.slideLevelState.slideStateMap,
                    })
                }
            })
            .catch(err => {
                console.log(err);
            })
    }

    enterLoading = (index) => {
        this.props.dispatch(updateLoaderState(true))
        this.setState(({ loadings }) => {
            const newLoadings = { ...loadings };
            newLoadings[index] = true;

            return {
                loadings: newLoadings,
            };
        });
    };

    removeLoading = (index) => {
        this.props.dispatch(updateLoaderState(false))
        this.setState(({ loadings }) => {
            const newLoadings = { ...loadings };
            newLoadings[index] = false;

            return {
                loadings: newLoadings,
            };
        });
    };

    call = (endpoint, options="", callback=null, show_info=true) => {
        // callback is called on 200 response code with response.data as argument
        let url = `/scano/1/api~hts~` + endpoint + options;
        console.log("path ", url, options);
        axios.get(url, { headers: { Authorization: AuthHeader() } })
            .then(response => {
                if (response.status !== 200) {
                    message.error("Error");
                    this.setState({
                        last_res: "Errored " + response.status
                    })
                    if(endpoint === "user_interaction_end"){//TODO:Fix This
                        this.onUserInteractionEnd()
                    }
                } else {
                    console.debug(response.data);
                    this.setState({
                        last_res: response.data.code + " " + response.data.message
                    })
                    if (show_info) {                        
                        message.info(response.data.code + " " + response.data.message);
                    } else {
                        console.log(response.data.code + " " + response.data.message);
                    }
                    if (callback !== null) {
                        callback(response.data);
                    }
                }
                this.removeLoading(endpoint);
            })
            .catch(err => {
                console.error(err);
                this.removeLoading(endpoint);
            })
    };

    pollQueueState = () => {
        this.updateScannerState(); // update scanner state (queue and slide level state)
    }

    doPolling = () => {
        this.getStatus();
    }

    componentDidMount = () => {
        this.getStatus();
        this.updateScannerState();
        this.timer = setInterval(this.doPolling, 4000);
        this.timer2 = setInterval(this.pollQueueState, 4000);
        // let _this = this;
        // this.timer3 = setInterval(function() {
        //     _this.props.dispatch(getDeviceStatus(this.props.device_id));
        // }, 1000);
        sagaMiddleware.run(watchPollStatus, this.props.dispatch, 1);
        this.props.dispatch(updateEditorState(false));
    }

    componentWillUnmount = () => {
        clearInterval(this.timer);
        clearInterval(this.timer2);
        // clearInterval(this.timer3);
        this.timer = null;
        this.timer2 = null;
        this.timer3 = null;
    }

    handleScannerShutdown = () => {
        this.setState({ shuttingDown: true }); // block UI and show spinner
        let device_id = this.device_id;
        let url = `/devices/` + device_id + '/stop_scanner_server/';
        console.trace(`GET request to shutdown scanner with device id ${device_id}`);
        axios.get(url, { headers: { Authorization: AuthHeader() } })
            .then(response => {
                if (response.status !== 200) {
                    message.error("Failed to Shutdown Scanner. Contact Admin!");
                    console.trace(`Scanner Shutdown failed, response.status is ${response.status}`);
                } else {
                    console.trace("Successful Scanner Shutdown request");
                }
                this.setState({ shuttingDown: false }); // unblock UI
            })
            .catch(err => {
                message.error("Failed to Shutdown Scanner. Contact Admin!");
                console.error(err);
                this.setState({ shuttingDown: false }); // unblock UI
            })
    }

    itemToString = (obj) => {
        const {rack, tray, slide} = obj;
        return `R${rack}T${tray}S${slide}`;
    }

    onUserInteractionEnd = () => {
        this.props.dispatch(getDeviceStatus(this.device_id));
        this.setState({show_long_loader: false});
        console.debug("Queue all scans now");
        // let tasks=["Removed tasks are : "]
        // if((((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).removedFromScanPreviewQueue.length!=0){
            
        //     for (const elem of (((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).removedFromScanPreviewQueue) {
        //         console.log("Removed these tasks: elem",elem)
        //         const {rack, tray, slide} = elem;
        //         const taskType = elem['taskType'];
        //         let key = `R${rack}T${tray}S${slide}`
        //         console.log("Removed these tasks: key",key)
        //         console.log("Removed these tasks: title",`${this.queueTitle(taskType)}R${rack}T${tray}S${slide}`)
        //         tasks.push(` ${this.queueTitle(taskType)}R${rack}T${tray}S${slide},`)
        //     }

        // this.removedTasks(tasks)
        // }
        // console.log("Removed these tasks: ",(((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).removedFromScanPreviewQueue)        
        this.getStatus(this.onStatusUpdateAfterUserInteractionEnd);
        this.setState({
            show_removed_tasks: true
        });
    }

    onStatusUpdateAfterUserInteractionEnd = () => {
        console.log("Adding to queue", this.state.data);
        const racks = (this.state.data || {}).rack_module.RACK;

        let orderedItemsToQueue = [];

        for (let i = 0; i < racks.length; i++) {
            for (let j = racks[i].length - 1; j >= 0; j--) {
                if (racks[i][j].barcode_taken) {
                    console.log("queue slot", i, j);
                    for (let slide = 0; slide < 6; slide++) {
                        orderedItemsToQueue.push({rack: i, tray: j, slide: slide});
                        // removed endpoint for this
                        // this.queueItem(i, j, slide);
                    }
                }
            }
        }
        // removed from backend
        // this.queueMultipleItems(orderedItemsToQueue);
        // this.enterLoading("queue_state");
        console.debug("onStatusUpdateAfterUserInteractionEnd: calling scanner_state");
        this.call("scanner_state", "", this.onGetQueueState, false);
    }

    onGetQueueState = (response) => {
        console.log("got scanner state", response);
        this.setState({queue_state: response.scanPreviewQueue});
    }

    // called when user clicks on a cassette from the small rack view
    onSelectCassette = (key) => {
        if(key!="R-1T-1"){
            this.setState({selected_cassette: key});
        }
    }

    onOpenGateAfterCurrentScan = () => {
        this.enterLoading("open_gate_after_ongoing");
        this.call("open_gate_after_ongoing", "", this.onOpenGateRequestSuccess, false);
        this.setState({show_long_loader: true});
    }
    onOpenGateRequestSuccess = () => {
        this.enterLoading("long_loader")
        console.debug("onOpenGateAfterCurrentScan callback is working");
    }

    // TODO: add confirmation.
    //       stops everything (even the current scan)
    onStopEverythingNowAndOpenGate = () => {
        this.enterLoading("user_interaction_start");
        this.call("stop_everything_now", "", this.onStopEverythingNowSuccess, false);
    }
    onStopEverythingNowSuccess = () => {
        this.removeLoading("user_interaction_start");
        console.log("will be stopped");
    }

    openGate = () => {
        this.enterLoading("user_interaction_start");
        let _this = this;
        const callback = () => {
            _this.props.dispatch(getDeviceStatus(_this.device_id));
        }
        this.call("user_interaction_start", "", callback);
    }

    onCloseGateBtnClick = () => {
        this.enterLoading("user_interaction_end");
        const mockHalapi = (((((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).mockConfig || {}).mockHalapi);
        this.setState({
            barcodeCacheBustingKey: (new Date()).getTime()
        });
        this.call("user_interaction_end", "?mock_halapi=" + mockHalapi.toString(), this.onUserInteractionEnd, false);
    }

    removedTaskConfirmation = () => {
        // this.setState({
        //     show_removed_tasks: false
        // });
        let _this = this;
        const callback = () => {
            console.debug("set show_removed_tasks to false");
            _this.setState({
                show_removed_tasks: false
            }); 
        }
        console.debug("calling endpoint to hide removed tasks");
        this.call("hide_removed_tasks", "", callback, false);
    }

    prioritiseTask = (e, rack, tray, slide, taskType) => {
        this.call("prioritise_task",`?rack=${rack}&tray=${tray}&slide=${slide}&taskType=${taskType}`, null, true)
    }

    removeTask = (e, rack, tray, slide, taskType) => {
        this.call("remove_task",`?rack=${rack}&tray=${tray}&slide=${slide}&taskType=${taskType}`, null, true)
    }

    showModal = () => {
        this.setState({modal_visible: true});
    };
    
    handleOk = () => {
        this.setState({modal_visible: false});
    };
    
    handleCancel = () => {
        this.setState({modal_visible: false});
    };

    stopAfterCurrentScan = () => {
        const _this = this;
        Modal.confirm({
          title: 'Open Gate After Current Scan',
          icon: <ExclamationCircleOutlined />,
          content: 'After the current scan or preview gets finished, scanning will pause and the gate will open',
          okText: 'OK',
          cancelText: 'Cancel',
          onOk() {
            _this.onOpenGateAfterCurrentScan();
        },
        });
        
    }

    stopNow = () => {
        const _this = this;
        Modal.confirm({
          title: 'Stop everything now and open the gate',
          icon: <ExclamationCircleOutlined />,
          content: 'Ongoing scan will be stopped immediately and the gate will open.',
          okText: 'OK',
          cancelText: 'Cancel',
          onOk() {
            _this.onStopEverythingNowAndOpenGate();
        },
        });
        
    }

    openGateBtn = () => {
        const _this = this;
        Modal.confirm({
          title: 'Open Gate',
          icon: <ExclamationCircleOutlined />,
          content: 'This will open the gate, allowing insertion of cassettes.',
          okText: 'OK',
          cancelText: 'Cancel',
          onOk() {
            _this.openGate();
        },
        });
        
    }

    removedTasks = (tasks) => {
        // this.setState({show_long_loader: false});
        const _this = this;
        Modal.confirm({
          title: 'Attention !',
          icon: <ExclamationCircleOutlined />,          
          content: tasks,
          okText: 'OK',          
        });
    }

    render() {
       
        // let is_superuser = cookie.loadAll().superuser === "true";
        console.debug("data", this.state.data, this.state.queue_state, this.state.scanner_state)
        let data = [];
        data.push(this.state.server_up ? <Text mark>{"Raspberry Server : ONLINE"}</Text> : "Raspberry Server : OFFLINE");
        data.push((this.state.data || {}).init_done ? <Text mark>{"Software Init : Done"}</Text> : "Software Init : Not Done");
        data.push((this.state.data || {}).homing_done ? <Text mark>{"Homing : Done"}</Text> : "Homing : Not Done");

        const rack_view = [];
        const slideLevelScanPreviewStatus = (((this.props.deviceStatus||{}).scanner_health||{}).scanner_response||{}).slideLevelScanPreviewStatus;
        if ((this.state.data || {}).rack_module) {
            rack_view.push(
                <RackView
                    key={"rack-view-0"}
                    racks = {(this.state.data || {}).rack_module.RACK} 
                    onSelectCassette = {this.onSelectCassette}
                    selected_cassette = {this.state.selected_cassette}
                    is_superuser = {this.state.is_superuser}
                    loadings = {this.state.loadings}
                    enterLoading = {this.enterLoading}
                    call = {this.call}
                    slideLevelScanPreviewStatus = {slideLevelScanPreviewStatus}
                />
            );

            const feeder_cassette = (this.state.data || {}).rack_module.soft_cassette_on_feeder;
            const stage_cassette = (this.state.data || {}).rack_module.soft_cassette_on_stage;
            data.push(feeder_cassette === null ? "[Soft] On Feeder : Empty" : 
            "[Soft] On Feeder : Rack " + (feeder_cassette || {}).rack + " Tray " + (feeder_cassette || {}).tray);
            data.push(stage_cassette === null ? "[Soft] On Stage : Empty" : 
            "[Soft] On Stage : Rack " + (stage_cassette || {}).rack + " Tray " + (stage_cassette || {}).tray);
        }

        // it doesn't make sense to show rack when user is changing scan region
        const show_rack = !this.state.change_scan_region;
        
        let queue = [];

        if ((this.state.queue_state)) {
           queue.push(
                <Col key={"q-col-0"} offset={1} span={18} >
                    <ScanPreviewQueueView 
                        queue_state={this.state.queue_state}
                        onSelectCassette={this.onSelectCassette}
                        prioritiseTask={this.prioritiseTask}
                        removeTask={this.removeTask}
                    />
                </Col>);
        }

        if ((this.state.data || {}).loader_module) {
            data.push((this.state.data || {}).loader_module.cassette_detected === true ? "[S] Detected : Cassette" : "[S] Detected : Empty");
            data.push((this.state.data || {}).loader_module.cassette_on_feeder === true ? "[S] Feeder : Cassette" : "[S] Feeder : Empty");
            data.push((this.state.data || {}).loader_module.y_on_stage === true ? "[S] Y On Stage : True" : "[S]  Y On Stage : False");
            data.push((this.state.data || {}).loader_module.y_under_stage === true ? "[S]  Y Under Stage : True" : "[S]  Y Under Stage : False");

            const loader_arm_pos = ((this.state.data || {}).loader_module.loader_position || {}).loader_arm_pos;
            data.push("Loader Arm Pos : ("  + loader_arm_pos.x + "," + loader_arm_pos.y + "," + loader_arm_pos.z + ")");

            const encoder_pos = ((this.state.data || {}).loader_module.loader_position || {}).encoder_pos;
            data.push("Encoder Pos : ("  + encoder_pos.x + "," + encoder_pos.y + "," + encoder_pos.z + ")");

            data.push("[S] Detector Val : " + (this.state.data || {}).loader_module.cassette_detected_sensor);
            data.push("[S] Feeder Val : " + (this.state.data || {}).loader_module.cassette_on_feeder_sensor);
        }

        let buttons = getDebugButtonList(this.state.loadings, this.enterLoading, this.call);

        console.debug("qPreviewBtnDisable is ", this.state.qPreviewBtnDisable);

        let singleCassetteView = [];
        if ((this.state.data || {}).rack_module) {
            let racks = (this.state.data || {}).rack_module.RACK;
            if (this.state.selected_cassette !== null) {
                const trayKey = this.state.selected_cassette;
                let cassetteState = {};
                for (let slide_id = 0; slide_id < 6; slide_id++) {
                    const slideKey = `${trayKey}S${slide_id}`;
                    cassetteState[slideKey] = this.state.scanner_state[slideKey];
                }
                let i = parseInt(trayKey.split("T")[0].split("R")[1]);
                let j = parseInt(trayKey.split("T")[1]);
                console.log("An-xx" ,(racks[i][j] || {}).cassette_type)
                let myCassetteType = (((racks[i][j] || {}).cassette_type || {})._name_ || cassetteType.SIX_1_BY_3_SLIDES);
                // myCassetteType = cassetteType.TWO_2_BY_3_SLIDES;
                singleCassetteView.push(
                    <ScanWorkflowC240 
                        key={"scan-workflow"}
                        selectedCassette={this.state.selected_cassette}
                        barcodeTaken={racks[i][j].barcode_taken}
                        cassetteState={cassetteState}
                        cassetteType={myCassetteType}
                        device_id={this.device_id}
                        queue_state={this.state.queue_state}
                        onStartChangeScanRegionCallback = {this.onStartChangeScanRegion}
                        onFinalizeScanRegionCallback = {this.onFinalizeScanRegion}
                        barcodeCacheBustingKey = {this.state.barcodeCacheBustingKey}
                        cassetteQPreviewBtnDisable = {this.state.qPreviewBtnDisable[this.state.selected_cassette]}
                        onPreviewOnlyClick = {this.onPreviewOnlyClick}
                        enablePreviewBtn = {this.enablePreviewBtn}
                        cassetteQScanBtnDisable = {this.state.qScanBtnDisable[this.state.selected_cassette]}
                        onQScanClick = {this.onQScanClick}
                        enableQScanBtn = {this.enableQScanBtn}
                        onFinalizeSlideSettingsClick = {this.onFinalizeSlideSettingsClick}
                        onFinalizedSlideSettings = {this.onFinalizedSlideSettings}
                        isCassetteEmpty = {racks[i][j].cassette_state._name_ === "EMPTY"} >
                    </ScanWorkflowC240>
                );
            }
        }
        if(singleCassetteView.length === 0){
            singleCassetteView = <p>Please select a cassette to see Slides.</p>
        }
        
        console.debug("initialized val is", (((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).initialized);
        console.debug("deviceStatus is", this.props.deviceStatus);
        if (((this.props.deviceStatus || {}).scanner_health || {}).server_up === false) {
            return <Redirect to={"/" + globalUrlPrefix + "/scanners/" + this.device_id + "/"}></Redirect>
        } else if ((((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).initialized === undefined) {
            return null;
        } else {
            return (
                <div>
                    {(((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).initialized === true ? null : <Redirect to={"/" + globalUrlPrefix + "/scanners/"+this.device_id+"/"}></Redirect>}
                    
                    <div className={((((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).gateOpen || !(((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).doneInteractingOnce) || (this.state.show_removed_tasks && !(((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).gateOpen && (((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).removedFromScanPreviewQueue.length!=0 ) ? "blur":""}>
                    {console.debug("show_loader",this.props.c240LoaderState.show_loader)}
                    <Spin 
                        spinning={this.props.c240LoaderState.show_loader ||
                                    this.state.show_long_loader ||
                                    this.state.finalizingSlideSettings ||
                                    this.state.shuttingDown}
                        tip={ this.state.loadings["user_interaction_start"] ? 
                              "Opening the Gate" 
                              : this.state.loadings["long_loader"] ? 
                                ((this.state.queue_state||{}).ongoing||{}).taskType === "OPEN_GATE" ?
                                 "Opening the Gate":"Waiting to finish the current Scan/Preview" 
                                 : this.state.finalizingSlideSettings ?
                                     "Finalzing Slide Settings" 
                                     : this.state.shuttingDown ? "Shutting Down Scanner" : "loading"}>
                    <Row className="rounded-container scanner-name-div">
                        <Col className="scanner-name arial-font" span={22}>
                        {((this.props.deviceStatus || {}).scanner_health || {}).device_name + " - Control Panel"}
                        </Col>
                        <Col span={2} style={{ marginTop: '12px' }}>
                            <Tooltip placement="bottom" title="Shutdown Scanner">
                                <PoweroffOutlined onClick={this.handleScannerShutdown} style={{ fontSize: '24px', color: '#ff7875' }} />
                            </Tooltip>
                        </Col>
                    </Row>
                    <Row>
                        <Col key={"cassette-view"} span={ show_rack ? 15 : 20 } style={ show_rack ? {} : { paddingRight: '10px' }}>
                            <Row key={"cassette-view-row"}>{singleCassetteView}</Row>
                            {/* <Divider /> */}
                            <Row key={"cassette-view-btns"} style={{ marginTop:'5vh'}}>
                                    <Modal title="Basic Modal" visible={this.state.modal_visible} onOk={this.handleOk} onCancel={this.handleCancel} okText="ok text" cancelText="cancel text">
                                        <p>Are you sure?</p>
                                    </Modal>
    
                                    { this.state.queue_state['ongoing'] === null && this.state.queue_state['queue'].length === 0 ? 
                                        <Button style={{marginLeft:'10px'}} onClick={this.openGateBtn} type="primary">
                                            Open Gate
                                        </Button>
                                        :
                                        <Row>
                                            <Button style={{marginLeft:'10px'}} onClick={this.stopAfterCurrentScan} type="primary">
                                                Stop After Current Scan/Preview
                                            </Button>
                                            <Tooltip placement="top" title="Stop current scan and open gate">
                                                <Button style={{marginLeft:'10px'}} onClick={this.stopNow} type="primary">Stop Now and Open Gate</Button>
                                            </Tooltip>
                                        </Row>
                                    }
                                    
                                    {/* {this.is_superuser_loggedin?<Switch checkedChildren="Admin" unCheckedChildren="User" style={{marginLeft:'10px'}} onClick={() => {this.state.is_superuser=!this.state.is_superuser}} />:null} */}
                            </Row>
                        </Col>
                        {show_rack ? 
                            <Col key={"rack-view"} span={5} className="rack-small-view" style={{fontSize: "10px"}}>
                                {rack_view}
                            </Col> 
                            : null
                        }
                        <Col key={"scan-preview-q"} span={4} style={{marginLeft:'-15px'}}>
                            {/* <div style={{height:'93or85vh', borderStyle:'groove', overflowY:'auto'}}> */}
                            <Row style={{fontSize: "12px",textAlign:"center"}}>Scan/Preview Queue</Row>
                            <div style={{height:'59vh', overflowY:'auto'}}>
                                {queue}
                            </div>
                        </Col>
                    </Row>
                        <br></br>
                    {this.state.is_superuser?<Row>
                        <Col span={3}>
                            <List
                            grid={{ gutter: 5, column: 1}}
                            size="small"
                            header={<div>Action Buttons</div>}
                            bordered
                            dataSource={buttons}
                            renderItem={item => <List.Item>{item}</List.Item>}
                            />
                        </Col>
                        <Col span={4} offset={1}>
                            <List
                            grid={{ gutter: 5, column: 1 }}
                            size="small"
                            header={<div>State Variables</div>}
                            bordered
                            dataSource={data}
                            style={{backgroundColor: this.state.server_up ? '#B4F6CE' : '#F5B9A9'}}
                            renderItem={item => <List.Item>{item}</List.Item>}
                          />
                          {"Last Response : " + this.state.last_res}
                        </Col>
                    </Row>:null}
                    </Spin>
                    </div>
                    
                    {console.debug("gateOpen",(((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).gateOpen )}
                    {console.debug("show_banner",(((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).doneInteractingOnce)}
                    {( (((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).gateOpen 
                        || !(((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).doneInteractingOnce) || (this.state.show_removed_tasks && !(((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).gateOpen && (((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).removedFromScanPreviewQueue.length!=0) ?
                            <GatePrompt 
                            handleProgressChange={this.props.handleProgressChange}
                            loadings = {this.state.loadings} 
                            device_id={this.props.device_id}
                            currentProcessIndex={this.props.currentProcessIndex} 
                            cassetteSize={this.state.cassetteSize}
                            prompt = { (((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).gateOpen ? 
                                        "CLOSE_GATE_PROMPT"
                                        : !(((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).doneInteractingOnce ? 
                                            "OPEN_GATE_PROMPT"
                                            : this.state.show_removed_tasks?
                                                "REMOVED_TASKS_PROMPT"
                                                : null }
                            closeGate = {(((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).gateOpen ? this.onCloseGateBtnClick : null}
                            openGate = {!(((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).doneInteractingOnce ? this.openGate : null}
                            removedTaskConfirmation = {this.state.show_removed_tasks && !(((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).gateOpen && (((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).removedFromScanPreviewQueue.length!=0 ? this.removedTaskConfirmation : null}
                            removedtasks = {this.state.show_removed_tasks && !(((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).gateOpen && (((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).removedFromScanPreviewQueue.length!=0 ? (((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).removedFromScanPreviewQueue : null}
                        />
                        
                        : null                                            
                    }
                    
                </div>
            )
        }
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        adminState: state.adminUrlReducer,
        c240LoaderState: state.c240LoaderReducer,
        deviceStatus: state.deviceStatusReducer[ownProps.match.params.id],
    };
};

export default connect(mapStateToProps)(C240ControlPanelView);
